import controller from './menu.controller';
import template from './menu.html';
import './menu.css';

const MenuComponent = {
    bindings: {
        elements: '<',
        active: '<',
        timeCounter: '<',
        paused: '<',
        language: '<',
        onChange: '&',
        onChangeStatus: '&',
    },
    controller,
    template,
};

export default MenuComponent;


//////////////////
// WEBPACK FOOTER
// ./src/menu/menu.component.js
// module id = 639
// module chunks = 0